import React, { useState } from "react";
import Icon from "components/AppIcon";
import DocumentAccessIndicator from "components/ui/DocumentAccessIndicator";
import Button from "components/ui/Button";

const FILE_ICONS = {
  pdf: "FileText",
  xlsx: "FileSpreadsheet",
  docx: "FileText",
  pptx: "Presentation",
  zip: "Archive",
};

export default function DocumentsPanel({ documents = [], onPreview, onUpload, isCoInvestor = false }) {
  const [filter, setFilter] = useState("all");

  const visibleDocs = isCoInvestor ? documents.filter((d) => d.access !== "restricted") : documents;
  const categories = ["all", ...Array.from(new Set(visibleDocs.map((d) => d.category)))];
  const filtered = filter === "all" ? visibleDocs : visibleDocs?.filter((d) => d?.category === filter);

  return (
    <div className="card flex flex-col h-full">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-heading text-base font-semibold text-foreground">Documents</h3>
        {!isCoInvestor && (
          <Button variant="outline" size="sm" iconName="Upload" iconPosition="left" iconSize={14} onClick={onUpload}>
            Upload
          </Button>
        )}
      </div>
      <div className="flex gap-1.5 flex-wrap mb-3">
        {categories?.map((cat) => (
          <button
            key={cat}
            onClick={() => setFilter(cat)}
            className={`font-caption text-xs px-2.5 py-1 rounded-full border transition-all duration-200 capitalize ${
              filter === cat
                ? "border-primary bg-primary text-primary-foreground"
                : "border-border text-muted-foreground hover:border-primary hover:text-primary"
            }`}
            style={filter === cat ? { background: "var(--color-primary)", borderColor: "var(--color-primary)" } : {}}
          >
            {cat}
          </button>
        ))}
      </div>
      <div className="flex-1 overflow-y-auto space-y-2 min-h-0">
        {filtered?.map((doc) => (
          <div
            key={doc?.id}
            className="flex items-center gap-3 p-2.5 rounded-lg border border-border hover:bg-muted transition-all duration-200 cursor-pointer group"
            onClick={() => onPreview && onPreview(doc)}
          >
            <div
              className="w-8 h-8 rounded flex items-center justify-center flex-shrink-0"
              style={{ background: "rgba(59,76,76,0.08)" }}
            >
              <Icon name={FILE_ICONS?.[doc?.ext] || "File"} size={16} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-caption text-sm font-medium text-foreground truncate">{doc?.name}</p>
              <div className="flex items-center gap-2 mt-0.5">
                <span className="font-caption text-xs text-muted-foreground">{doc?.size}</span>
                <span className="text-muted-foreground">·</span>
                <span className="font-caption text-xs text-muted-foreground">{doc?.updatedAt}</span>
                <span className="font-data text-xs text-muted-foreground">v{doc?.version}</span>
              </div>
            </div>
            <DocumentAccessIndicator accessStatus={doc?.access} compact documentCount={1} />
            <Icon
              name="Download"
              size={14}
              color="var(--color-muted-foreground)"
              className="opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0"
            />
          </div>
        ))}
      </div>
      <div className="mt-3 pt-3 border-t border-border">
        <p className="font-caption text-xs text-muted-foreground">{filtered?.length} documents{isCoInvestor ? "" : " · Audit trail enabled"}</p>
      </div>
    </div>
  );
}